// const KValueTypes = [
//   "STRING",
//   "alfanumerico",
//   "NUMBER_INTEGER",
//   "NUMBER_LONG",
//   "numerico",
//   "NUMBER_BIG_INTEGER",
//   "NUMBER_BIG_DECIMAL",
//   "NUMBER_FLOAT",
//   "NUMBER_DOUBLE",
//   "BOOLEAN",
//   "DATE",
//   "TIME",
//   "DATETIME",
//   "DATE_LEGACY",
//   "data",
// ];

const ConcatOperators = Object.freeze(["AND", "OR"]);

const Operators = Object.freeze({
  EQUALS: {
    key: "E",
    symbol: "=",
    icon: "&#61;",
  },
  NOT_EQUALS: {
    key: "NE",
    symbol: "!=",
    icon: "&ne;",
  },
  LESS_THAN: {
    key: "LT",
    symbol: "<",
    icon: "&lt;",
  },
  LESS_EQUAL_THAN: {
    key: "LET",
    symbol: "<=",
    icon: "&leq;",
  },
  GREATER_THAN: {
    key: "GT",
    symbol: ">",
    icon: "&gt;",
  },
  GREATER_EQUAL_THAN: {
    key: "GET",
    symbol: ">=",
    icon: "&geq;",
  },
  LIKE: {
    key: "LIKE",
    symbol: "LIKE",
    icon: "~",
  },
  BETWEEN: {
    key: "BETWEEN",
    symbol: "[a,b]",
    icon: "[a,b]",
  },
  IN: {
    key: "IN",
    symbol: "in",
    icon: "in",
  },
});

const comparisonOperatorGroup1 = [
  {
    key: "E",
    symbol: "=",
    icon: "&#61;",
  },
  {
    key: "NE",
    symbol: "!=",
    icon: "&ne;",
  },
  {
    key: "LT",
    symbol: "<",
    icon: "&lt;",
  },
  {
    key: "LET",
    symbol: "<=",
    icon: "&leq;",
  },
  {
    key: "GT",
    symbol: ">",
    icon: "&gt;",
  },
  {
    key: "GET",
    symbol: ">=",
    icon: "&geq;",
  },
  {
    key: "LIKE",
    symbol: "LIKE",
    icon: "~",
  },
];

const baseOperators = Object.freeze([
  Operators.EQUALS,
  Operators.NOT_EQUALS,
  Operators.GREATER_THAN,
  Operators.GREATER_EQUAL_THAN,
  Operators.LESS_THAN,
  Operators.LESS_EQUAL_THAN,
]);

// const comparisonOperatorGroup2 = [
//   ...comparisonOperatorGroup1,
//   {
//     key: "LIKE",
//     symbol: "LIKE",
//   },
// ];

const KValueTypes = {
  STRING: {
    operators: [...comparisonOperatorGroup1],
  },
  alfanumerico: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_INTEGER: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_LONG: {
    operators: [...comparisonOperatorGroup1],
  },
  numerico: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_BIG_INTEGER: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_BIG_DECIMAL: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_FLOAT: {
    operators: [...comparisonOperatorGroup1],
  },
  NUMBER_DOUBLE: {
    operators: [...comparisonOperatorGroup1],
  },
  BOOLEAN: {
    operators: [...comparisonOperatorGroup1],
  },
  DATE: {
    operators: [...baseOperators, Operators.BETWEEN],
  },
  TIME: {
    operators: [...baseOperators, Operators.BETWEEN],
  },
  DATETIME: {
    operators: [...baseOperators, Operators.BETWEEN],
  },
  DATE_LEGACY: {
    operators: [...baseOperators, Operators.BETWEEN],
  },
  data: {
    operators: [...baseOperators, Operators.BETWEEN],
  },
};

function getOperatorsList() {
  return Object.values(Operators);
}

const checkType = {
  isDate(type) {
    return type === "data" || type === "DATE" || type === "DATE_LEGACY";
  },
  isDateTime(type) {
    return type === "DATETIME" || type === "DATETIME_LEGACY";
  },
  isTime(type) {
    return type === "TIME" || type === "TIME_LEGACY";
  },
};
export { Operators, KValueTypes, ConcatOperators, getOperatorsList, checkType };
